export const roundN = (value: number, digits: number) => {
  var tenToN = 10 ** digits;
  return /*Math.trunc*/ Math.round(value * tenToN) / tenToN;
};
